import { createSelector } from 'reselect';
import config from 'Config/appConfig';

const getGeos = ({ router: { geos = [] } }) => geos;
const getIndicators = ({ router: { indicators = [] } }) => indicators;

const shouldDisplayWarning = (geos, indicators) =>
  config.performanceWarning.maxIndicators < indicators.length &&
    ('all' === geos ||
      config.performanceWarning.maxGeos < geos.length
    );

const shouldDisplayWarningSelector = createSelector(
  [getGeos, getIndicators],
  shouldDisplayWarning
);

export default shouldDisplayWarningSelector;

export { shouldDisplayWarning };



// WEBPACK FOOTER //
// ./app/selectors/shouldDisplayWarning.js